import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=7143b053&"
import script from "./tasks.vue?vue&type=script&lang=js&"
export * from "./tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports